import React, { useState } from 'react';
import { Button, Drawer, Grid } from 'antd';
import { EsimGuideContent } from '../../pages/admin/EsimGuide';

const { useBreakpoint } = Grid;

interface EsimGuideLinkProps {
  children?: React.ReactNode;
}

// KAN-167: link-styled button that opens the eSIM guide in a drawer on top of
// whatever the operator is doing. A real link to /admin/esim-guide in a new tab
// lands on the login page: auth tokens are kept in sessionStorage, which is per
// tab. The full page still exists in the sidebar for direct reading.
const EsimGuideLink: React.FC<EsimGuideLinkProps> = ({
  children = 'How eSIM provisioning works',
}) => {
  const [open, setOpen] = useState(false);
  const screens = useBreakpoint();
  const drawerProps = screens.md
    ? { placement: 'right' as const, width: 720 }
    : { placement: 'bottom' as const, height: '90vh' };
  return (
    <>
      <Button
        type="link"
        size="small"
        style={{ padding: 0, height: 'auto' }}
        onClick={() => setOpen(true)}
      >
        {children}
      </Button>
      <Drawer
        title="Travel eSIM guide"
        open={open}
        onClose={() => setOpen(false)}
        zIndex={1100}
        {...drawerProps}
      >
        <EsimGuideContent />
      </Drawer>
    </>
  );
};

export default EsimGuideLink;
